import window from 'global/window';

export const isSafari = window.safari != null;
